import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router'
import Head from 'next/head'
import { DefaultLayout } from '../../../layouts'
import AppContext from '../../../components/common/AppContext'
const RecommendationEngine = dynamic(() => import('../../../components/common/RecommendationEngine.js'), {
  ssr: false
});

function RecommendationEngineComponent(props) {
  const router = useRouter()
  let slug_text = ''
  let title = 'SimplyBuy AI Recommendation Engine'
  let description = 'Get recommendations on any category of products unique to your needs in just minutes!'

  const useAppContext = () => useContext(AppContext);
  const { logged_in, handlelogin } = useAppContext();
  console.log(handlelogin)
  return (
      <div>
      <Head>
        <title>{title}</title>
        <meta name='description' content={description}/>
      </Head>
        <RecommendationEngine
          handlelogin={handlelogin}
          logged_in={logged_in}
          router={router}/>
      </div>
  )
}

// RecommendationEngineComponent.getLayout = function getLayout(page) {
//   return (
//     <DefaultLayout>
//       {page}
//     </DefaultLayout>
//   )
// }

RecommendationEngineComponent.getInitialProps = async (props) => {
  let { slug } = props.query
  slug = slug.replace('-', ' ')
  console.log(slug)
  return { slug: slug }
}

export default RecommendationEngineComponent
